import React from 'react';
import ProfileDetails from '../components/ProfileDetails';

const ProfileContainer = () => <ProfileDetails />;

export default ProfileContainer;
